import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { useTranslations } from '@/i18n/TranslationsProvider';
import { PlayerDetailsForm } from '@/ui/profile';

export const Route = createFileRoute('/profile/details')({
  component: ProfileDetailsPage,
});

function ProfileDetailsPage() {
  const { t, i18n } = useTranslation();
  const { selectedLanguage } = useTranslations();
  const isTranslationReady =
    selectedLanguage === 'en' || i18n.hasResourceBundle(selectedLanguage, 'translation');
  const label = (key: string, fallback: string) =>
    isTranslationReady ? t(key, { defaultValue: fallback }) : fallback;

  return (
    <div className="flex flex-col gap-4 lg:gap-6">
      <header className="flex flex-col gap-1 lg:gap-2">
        <h1 className="text-[18px] font-bold text-text-primary lg:text-[22px]">
          {label('Player Details', 'Player Details')}
        </h1>
        <p className="text-[13px] text-text-secondary">
          <span className="lg:hidden">
            {label(
              'Update your personal and contact information.',
              'Update your personal and contact information.',
            )}
          </span>
          <span className="hidden lg:inline">
            {label(
              'Review and update your personal information, contact details, and password.',
              'Review and update your personal information, contact details, and password.',
            )}
          </span>
        </p>
      </header>
      <PlayerDetailsForm />
    </div>
  );
}
